var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-boxes-container"},_vm._l((_vm.data),function(item){return _c('partner-box',{key:item.id,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }